import { ConfirmService } from './../../../../../core/components/confirm/confirm.service';
import { Component, OnInit, ViewChild, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PowerBiDialogComponent } from './powerbi-dialog.component';

import { Router, NavigationEnd } from '@angular/router';
import { NotificacionesService } from '../../../../../core/notificaciones/notificaciones.service';
import { Powerbi } from '../../../../../core/modelos/powerbi';
import { PowerBiService } from './powerbi.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-powerbi-tabla',
    templateUrl: './powerbi-tabla.component.html',
    styleUrls: ['./powerbi-tabla.component.scss']
})
export class PowerbiTablaComponent implements OnInit, AfterViewInit {

    // Tabla informes PowerBI
    displayedColumns: any;
    dataSource: MatTableDataSource<Powerbi>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() informes: Powerbi[];
    @Input() activoId: number;
    @Input() editando: boolean;
    @Input() esAdminBod: boolean;

    @Output() cambioPowerBis = new EventEmitter<boolean>();

    powerBiDialogRef: MatDialogRef<PowerBiDialogComponent>;

    constructor(
        private dialog: MatDialog,
        private powerBiService: PowerBiService,
        private router: Router,
        private confirmService: ConfirmService,
        private notificaciones: NotificacionesService,
        private translate: TranslateService
    ) {


        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };

        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                // trick the Router into believing it's last link wasn't previously loaded
                this.router.navigated = false;
                // if you need to scroll back to top, here is the right place
                window.scrollTo(0, 0);
            }
        });
        setTimeout(() => {
            this.editando ? this.displayedColumns = ['id', 'descripcion', 'ruta', 'acciones'] : this.displayedColumns = ['id', 'descripcion', 'ruta'];
        }, 0);
    }

    ngOnInit() {
        if (this.esAdminBod) {
            this.editando ? this.displayedColumns = ['id', 'descripcion', 'ruta', 'acciones'] : this.displayedColumns = ['id', 'descripcion', 'ruta'];
        } else {
            this.editando ? this.displayedColumns = ['descripcion', 'ruta', 'acciones'] : this.displayedColumns = ['descripcion', 'ruta'];
        }
    }

    ngAfterViewInit() {

        if (this.informes.length) {

            setTimeout(() => {

                this.dataSource = new MatTableDataSource(this.informes);

                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;

                // Traduzco etiqueta si es español
                if (this.translate.currentLang === 'es') {
                    this.paginator._intl.itemsPerPageLabel = this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ItemsPorPagina;
                }

            }, 0);
        }


    }

    openPowerBIDialog(informe?: Powerbi) {

        const indice = this.informes.indexOf(informe);

        this.powerBiDialogRef = this.dialog.open(PowerBiDialogComponent, {
            data: {
                id: indice !== -1 ? informe.id : '',
                descripcion: indice !== -1 ? informe.descripcion : '',
                ruta: indice !== -1 ? informe.ruta : '',
                activo_id: this.activoId
            }
        });

    }

    deletePowerBi(informe?: Powerbi) {

        this.confirmService.confirm(
            this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.TituloBorrar,
            this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.MensajeBorrar).subscribe(
                result => {
                    if (result) {
                        this.powerBiService.deletePowerBi(informe.id).subscribe( // TODO: cambiar a nuevo servicio
                            data => {
                                if (data.success) {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.Borrado);
                                    this.router.navigate(['/activos/editar', this.activoId]);
                                } else {
                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.PowerBi.NOBorrado);
                                }
                            },
                            err => {
                                this.notificaciones.errorServidor(err.status);
                            }
                        );
                    }
                }
            );


    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/components/powerbi-tabla/powerbi-tabla.component.ts